import { useLocation } from 'react-router-dom';
import { useModalsContext } from '../../providers/ModalsProvider/Modals.context';
import { toChatModalLead } from '../AdvanceSearch/AdvanceSearchModal.functions';
import { tAdvanceSearchLead } from '../AdvanceSearch/AdvanceSearchModal.types';
import { RouterPaths } from '../Router/Router.constants';
import { tLeadChatTarget } from './LeadChat.functions';

/**
 * The smallest lead the chat accepts for a link that only knows the id and
 * channel. Nothing else is invented: the chat fetches the lead by id on open.
 * Nothing vouches for the viewer seeing it either, so the popup checks first.
 */
export function toLeadChatModalLead(target: tLeadChatTarget): tAdvanceSearchLead {
  return toChatModalLead({
    id: target.leadId,
    ...(target.integration && { chat: { integration: target.integration } }),
    tags: [],
    accessUnverified: true,
  });
}

/**
 * Opens a lead's conversation without leaving the current view (AGI-761):
 * on `/workspace/chat` the main chat switches to the lead in place; anywhere
 * else the global chat popup opens over the page, or swaps to this lead when
 * it is already open.
 */
export default function useOpenLeadChat() {
  const { pathname } = useLocation();
  const { setSelectedLeadForChatModal, setChatModalIsOpen } = useModalsContext();

  return (lead: tAdvanceSearchLead) => {
    setSelectedLeadForChatModal(lead);
    if (!pathname.startsWith(RouterPaths.chat)) setChatModalIsOpen(true);
  };
}
